import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import "./SingleWork.css";

export default function SingleWork() {
  const { id } = useParams();
  const [card, setCard] = useState(null);

  useEffect(() => {
    const fetchCard = async () => {
      const docRef = doc(db, "workCards", id);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setCard({ id: docSnap.id, ...docSnap.data() });
      } else {
        setCard(null);
      }
    };

    fetchCard();
  }, [id]);

  if (!card) return <p className="loading">Loading...</p>;

  return (
    <div className="single-work-container">
      <div className="single-work-content">
        <div className="image-side">
          <img src={card.image} alt={card.title} />
        </div>

        <div className="text-side">
          <h1>{card.title}</h1>
          {card.summary && <p className="summary">{card.summary}</p>}
          <p>{card.description}</p>

          <div className="details">
            {card.category && <p><strong>Category:</strong> {card.category}</p>}
            {card.type && <p><strong>Type:</strong> {card.type}</p>}
            {card.material && <p><strong>Material:</strong> {card.material}</p>}
            {card.color && <p><strong>Color:</strong> {card.color}</p>}
            {card.price && <p><strong>Price:</strong> €{card.price}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
